export default __webpack_public_path__ + "static/media/backup.a139ebde.png";